import { PropsWithChildren } from 'react';

import { Box } from '@mui/material';

import styles from './TopBar.module.scss';

export const TopBar: React.FC<PropsWithChildren> = ({ children }) => (
  <Box className={styles.outer}>
    <Box className={styles.inner}>{children}</Box>
  </Box>
);
